import { render, staticRenderFns } from "./work.vue?vue&type=template&id=32c49f79&scoped=true"
import script from "./work.vue?vue&type=script&lang=js"
export * from "./work.vue?vue&type=script&lang=js"
import style0 from "./work.vue?vue&type=style&index=0&id=32c49f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c49f79",
  null
  
)

export default component.exports